import { ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import FolderIcon from '@mui/icons-material/Folder';
import { Category } from '../types/bookmarks';
import { useCategoryContext } from '../contexts/CategoryContext';

interface CategoryFolderItemProps {
  category: Category;
}

const CategoryFolderItem = ({ category }: CategoryFolderItemProps) => {
  const { selectCategory } = useCategoryContext();

  return (
    <ListItemButton
      onClick={() => selectCategory(category)}
      sx={{ minHeight: 48, width: '100%' }}
    >
      <ListItemIcon>
        <FolderIcon />
      </ListItemIcon>
      <ListItemText primary={category.category_name} />
    </ListItemButton>
  );
};

export default CategoryFolderItem;
